export const FETCH_PAYMENT_DELIVERY_RANGES_PENDING =
  'FETCH_PAYMENT_DELIVERY_RANGES_PENDING';
export const FETCH_PAYMENT_DELIVERY_RANGES_REJECTED =
  'FETCH_PAYMENT_DELIVERY_RANGES_REJECTED';
export const FETCH_PAYMENT_DELIVERY_RANGES_FULFILLED =
  'FETCH_PAYMENT_DELIVERY_RANGES_FULFILLED';
export const CLEAR_PAYMENT_DELIVERY_RANGES = 'CLEAR_PAYMENT_DELIVERY_RANGES';



// WEBPACK FOOTER //
// ./src/constants/paymentDeliveryRanges.js